/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ today: NonNullable<unknown>, planned: NonNullable<unknown> }} Workout_Item_CutInputs */

const en_us2_workout_item_cut = /** @type {(inputs: Workout_Item_CutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.today} of ${i?.planned}`)
};

const pt_br2_workout_item_cut = /** @type {(inputs: Workout_Item_CutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.today} de ${i?.planned}`)
};

const es_419_workout_item_cut = /** @type {(inputs: Workout_Item_CutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.today} de ${i?.planned}`)
};

const pt_pt2_workout_item_cut = /** @type {(inputs: Workout_Item_CutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.today} de ${i?.planned}`)
};

const fr_fr2_workout_item_cut = /** @type {(inputs: Workout_Item_CutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.today} sur ${i?.planned}`)
};

const de_de2_workout_item_cut = /** @type {(inputs: Workout_Item_CutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.today} von ${i?.planned}`)
};

const it_it2_workout_item_cut = /** @type {(inputs: Workout_Item_CutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.today} di ${i?.planned}`)
};

/**
* | output |
* | --- |
* | "{today} of {planned}" |
*
* @param {Workout_Item_CutInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_item_cut = /** @type {((inputs: Workout_Item_CutInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Item_CutInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_item_cut(inputs)
	if (locale === "es-419") return es_419_workout_item_cut(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_item_cut(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_item_cut(inputs)
	if (locale === "de-DE") return de_de2_workout_item_cut(inputs)
	if (locale === "it-IT") return it_it2_workout_item_cut(inputs)
	return en_us2_workout_item_cut(inputs)
});
export { workout_item_cut as "workout.item_cut" }